import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";
import BrandHero from "./components/BrandHero";
import ServiceList from "./components/ServiceList";
import CaseGrid from "./components/CaseGrid";
import ContactForm from "./components/ContactForm";

const contacts = [
  { icon: "ri-mail-line", label: "商务邮箱", value: "hi@xiaomitao.com" },
  { icon: "ri-phone-line", label: "合作热线", value: "400-000-2026" },
  { icon: "ri-map-pin-line", label: "办公地址", value: "城市创意园区 A 座 12 层" },
  { icon: "ri-time-line", label: "工作时间", value: "周一至周五 10:00 - 19:00" },
];

export default function BrandPage() {
  usePageMeta({
    title: "小蜜桃 - 品牌服务与内容合作",
    description:
      "小蜜桃品牌服务涵盖内容策划与制作、品牌传播与整合营销、共创与联合出品，欢迎创作者与品牌一起把好内容讲给更多人。",
    keywords: "小蜜桃,品牌服务,内容策划,品牌传播,合作案例",
  });

  return (
    <SiteLayout>
      <BrandHero />
      <ServiceList />
      <CaseGrid />

      <section className="w-full px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              联系我们
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">
              无论你是品牌方、创作者还是机构伙伴，只要想法足够真诚，我们都愿意聊聊。
            </p>

            <div className="mt-6 flex flex-col gap-3">
              {contacts.map((c) => (
                <div
                  key={c.label}
                  className="flex items-center gap-3 bg-background-50 border border-background-200 rounded-lg p-4"
                >
                  <span className="w-10 h-10 shrink-0 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">{c.label}</p>
                    <p className="text-sm text-foreground-900">{c.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg overflow-hidden bg-background-200 h-44">
              <iframe
                title="小蜜桃办公位置地图"
                src="https://gwejdf.cn/maps?q=Shanghai%20creative%20park&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}